import { AlertMessageComponent } from './alert-message/alert-message.component';
import { DeactivateRouteGuard } from './auth-guard/deactivate-route.guard';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SignupsuccessComponent } from './signupsuccess/signupsuccess.component';
import { SignupcompleteComponent } from './signupcomplete/signupcomplete.component';
import { ForgetpasswordComponent } from './forgetpassword/forgetpassword.component';
import { PasswordrequestsuccessComponent } from './passwordrequestsuccess/passwordrequestsuccess.component';
import { OauthGuard } from './services/oauth-guard.service';
import { CompanySummaryComponent } from './company-summary/company-summary.component';
import { CompanySummary2Component } from './company-summary2/company-summary2.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { EmailPinVerificationComponent } from './email-pin-verification/email-pin-verification.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { PasswordresetsuccessComponent } from './passwordresetsuccess/passwordresetsuccess.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { InvitationExpireComponent } from './invitation-expire/invitation-expire.component';

const routes: Routes = [
  { path: 'signup', component: SignupComponent },
  { path: 'signup/:email', component: SignupComponent },
  { path: 'login', component: LoginComponent },
  { path: '', component: LoginComponent },
  { path: 'forget-password', component: ForgetpasswordComponent },
  { path: 'signup-success', component: SignupsuccessComponent },
  { path: 'signup-complete', component: SignupcompleteComponent },
  { path: 'passwordrequestSuccess', component: PasswordrequestsuccessComponent },
  { path: 'resetPassword/:userUniqueCode', component: PasswordresetComponent },
  { path: 'passwordresetsuccess', component: PasswordresetsuccessComponent },
  { path: 'companySummary', component: CompanySummaryComponent },
  { path: 'companySummary2', component: CompanySummary2Component },
  { path: 'termsAndConditions', component: TermsAndConditionsComponent, canDeactivate: [DeactivateRouteGuard] },
  { path: 'emailverification/:emailVerificationCode', component: EmailPinVerificationComponent },
  { path: 'invitationExpire', component: InvitationExpireComponent },
  { path: 'my-profile/:customerId', component: WelcomeComponent },
  { path: 'notActive', component: AlertMessageComponent },
  { path: 'pages', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [OauthGuard] }
];

const config: ExtraOptions = {
    useHash: true
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
